import { SeeqNames } from '@/main/app.constants.seeqnames';

export const WORKBOOK_VERSIONED_ITEM_TYPES = [SeeqNames.Types.Analysis];
